import moment from "moment";
import { BOOKING_TYPE, DEFAULT_CURRENCY_CODE } from "../constants/variables";
import { getLowFareForMonth } from "../dataLayer/lowFares";
import { extractResource } from "../helper/extractResource";
import { deepCopy } from "../utils/jsonUtils";
import { calculateJourneyDuration, calculateLegDuration, calculateLegLayoverDuration, calculateSegmentDuration, calculateSegmentLayoverDuration, getDurationString } from "helper/duration";

// this function is depreacted
export async function getFlightDetails(currentBooking, airports) {
  const flightInfoArray = [];

  try {
    if (
      typeof currentBooking.currentBookingDetails !== "undefined" &&
      typeof currentBooking.currentBookingDetails.journeys !== "undefined" &&
      currentBooking.currentBookingDetails.journeys.length > 0
    )
      for (let index = 0; index < currentBooking?.currentBookingDetails?.journeys.length; index++) {
        const tempFlightDetails = [];

        const currentJourney = currentBooking.currentBookingDetails.journeys[index];
        const originAirport = airports?.find((item) => item?.stationCode === currentJourney.designator.origin);
        const destinationAirport = airports?.find(
          (item) => item?.stationCode === currentJourney.designator.destination
        );
        tempFlightDetails.flightType = currentJourney.flightType;
        tempFlightDetails.stops = currentJourney.stops;
        tempFlightDetails.origin = currentJourney.designator.origin;
        tempFlightDetails.originAirport = originAirport;
        tempFlightDetails.destinationAirport = destinationAirport;
        tempFlightDetails.destination = currentJourney.designator.destination;
        tempFlightDetails.arrival = moment(currentJourney.designator.arrival).format("D MMM YY");
        tempFlightDetails.arrivalTime = moment(currentJourney.designator.arrival).format("HH:mm");
        tempFlightDetails.departure = moment(currentJourney.designator.departure).format("D MMM YY");
        tempFlightDetails.departureTime = moment(currentJourney.designator.departure).format("HH:mm");
        tempFlightDetails.arrivalDateFormate2 = moment(currentJourney.designator.arrival).format("ddd, D MMM");
        tempFlightDetails.departureDateFormate2 = moment(currentJourney.designator.departure).format("ddd, D MMM");
        tempFlightDetails.duration = getDurationString(calculateJourneyDuration(currentJourney));

        // get the segment for flight number :
        for (let index_j = 0; index_j < currentJourney.segments.length; index_j++) {
          const flightInfo = currentJourney.segments[index_j];
          tempFlightDetails.flightNumber = flightInfo.identifier.carrierCode + flightInfo.identifier.identifier;
          // terminal info
          for (let index_k = 0; index_k < flightInfo.legs.length; index_k++) {
            const legInfo = flightInfo.legs[index_k];
            if (legInfo.legInfo.arrivalTerminal != null) {
              tempFlightDetails.arrivalTerminal = legInfo.legInfo.arrivalTerminal;
            }
            if (legInfo.legInfo.departureTerminal != null) {
              tempFlightDetails.departureTerminal = legInfo.legInfo.departureTerminal;
            }
            flightInfoArray.push(tempFlightDetails);
          }
        }
      }
    return flightInfoArray;
  } catch (error) {
    console.warn(error);
  }
  return flightInfoArray;
}

export async function getTripInfo(currentBooking) {
  let response = {
    journeyType: "",
    origin: "",
    destination: "",
    recordLocator: "",
    currentStatus: "",
    passengerCount: 1
  };
  const recordLocator = currentBooking?.recordLocator;
  const currentStatus = currentBooking?.info?.status;
  const passengerCount = 1;
  try {
    let journeys = [];
    let passengerCount: any;
    if (typeof currentBooking?.journeys !== "undefined" && currentBooking?.journeys.length > 0) {
      journeys = currentBooking.journeys;
      passengerCount = currentBooking?.passengers.length;
    }
    if (
      typeof currentBooking.currentBookingDetails !== "undefined" &&
      typeof currentBooking.currentBookingDetails?.journeys !== "undefined" &&
      currentBooking.currentBookingDetails?.journeys.length > 0
    ) {
      journeys = currentBooking?.currentBookingDetails?.journeys;
      passengerCount = currentBooking?.currentBookingDetails?.passengers.length;
    }
    if (journeys.length > 0) {
      if (journeys.length === 1) {
        response = {
          journeyType: BOOKING_TYPE.ONE_WAY,
          origin: journeys[0].designator.origin,
          destination: journeys[0].designator.destination,
          recordLocator,
          currentStatus,
          passengerCount
        };
      } else if (journeys.length === 2) {
        if (journeys[0].designator.origin === journeys[1].designator.destination) {
          response = {
            journeyType: BOOKING_TYPE.ROUND_TRIP,
            origin: journeys[0].designator.origin,
            destination: journeys[0].designator.destination,
            recordLocator,
            currentStatus,
            passengerCount
          };
        }
      }
    }
  } catch (error) {
    console.warn(error);
  }

  return response;
}

export async function displayCalenderObject(
  origin = "BLR",
  destination = "AMD",
  startDate,
  endDate,
  tripType = BOOKING_TYPE.ONE_WAY,
  selectedCurrency = DEFAULT_CURRENCY_CODE
) {
  let selectedDateIndex: any = 0;
  let selectedDateIndexForRound: any = 0;
  selectedDateIndex = moment(startDate).diff(moment(startDate), "days");
  selectedDateIndexForRound = parseInt(moment(startDate).diff(moment(endDate), "days"), 10);
  startDate = new Date(new Date(startDate));
  // startDate = new Date(new Date(moment(startDate, "DD-MM-YYYY").add(0,'days').format("YYYY-MM-DD")));
  const apiResponse = [];
  let tempApiResponse: any = await getLowFareForMonth(origin, destination, startDate, selectedCurrency);
  apiResponse.push(tempApiResponse?.data?.data);
  if (tripType === BOOKING_TYPE.ROUND_TRIP) {
    selectedDateIndexForRound = parseInt(moment(endDate).diff(moment(endDate), "days"), 10);
    tempApiResponse = await getLowFareForMonth(destination, origin, endDate, selectedCurrency);
    apiResponse.push(tempApiResponse?.data?.data);
  }

  const apiData = {
    journeyDates: apiResponse,
    selectedIndex: [selectedDateIndex, selectedDateIndexForRound]
  };
  return apiData;
}

export async function getFlightDetailsV2(currentBooking, airports) {
  let flightInfoArray = [];
  const journeyDetails = [];
  try {
    if (
      typeof currentBooking.currentBookingDetails !== "undefined" &&
      typeof currentBooking.currentBookingDetails.journeys !== "undefined" &&
      currentBooking.currentBookingDetails.journeys.length > 0
    )
      for (let index = 0; index < currentBooking?.currentBookingDetails?.journeys.length; index += 1) {
        const tempFlightDetails = [];
        flightInfoArray = [];
        const currentJourney = currentBooking.currentBookingDetails.journeys[index];
        const originAirport = airports?.find((item) => item?.stationCode === currentJourney.designator.origin);
        const destinationAirport = airports?.find(
          (item) => item?.stationCode === currentJourney.designator.destination
        );
        tempFlightDetails.flightType = currentJourney.flightType;
        tempFlightDetails.stops = currentJourney.stops;
        tempFlightDetails.origin = currentJourney.designator.origin;
        tempFlightDetails.originAirport = originAirport;
        tempFlightDetails.destinationAirport = destinationAirport;
        tempFlightDetails.destination = currentJourney.designator.destination;
        tempFlightDetails.arrival = moment(currentJourney.designator.arrival).format("D MMM YY");
        tempFlightDetails.arrivalTime = moment(currentJourney.designator.arrival).format("HH:mm");
        tempFlightDetails.departure = moment(currentJourney.designator.departure).format("D MMM YY");
        tempFlightDetails.departureTime = moment(currentJourney.designator.departure).format("HH:mm");
        tempFlightDetails.arrivalDateFormate2 = moment(currentJourney.designator.arrival).format("ddd, D MMM");
        tempFlightDetails.departureDateFormate2 = moment(currentJourney.designator.departure).format("ddd, D MMM");

        const duration = calculateJourneyDuration(currentJourney);
        tempFlightDetails.duration = getDurationString(duration);
        
        tempFlightDetails.flightType = currentJourney?.flightType;
        // get the segment for flight number :
        for (let index_j = 0; index_j < currentJourney.segments.length; index_j++) {
          const flightInfo = currentJourney.segments[index_j];
          const segmentFlightDetails = {};
          segmentFlightDetails.flightNumber = flightInfo.identifier.carrierCode + flightInfo.identifier.identifier;
          const currentJourneySegment = deepCopy(currentBooking.currentBookingDetails.journeys[index]);
          const originAirportSegment = airports?.find((item) => item?.stationCode === flightInfo.designator.origin);
          const destinationAirportSegment = airports?.find(
            (item) => item?.stationCode === flightInfo.designator.destination
          );
          segmentFlightDetails.origin = flightInfo.designator.origin;
          segmentFlightDetails.flightType = currentJourney.flightType;
          segmentFlightDetails.originAirport = originAirportSegment;
          segmentFlightDetails.destinationAirport = destinationAirportSegment;
          segmentFlightDetails.destination = flightInfo.designator.destination;
          segmentFlightDetails.arrival = moment(flightInfo.designator.arrival).format("D MMM YY");
          segmentFlightDetails.arrivalTime = moment(flightInfo.designator.arrival).format("HH:mm");
          segmentFlightDetails.departure = moment(flightInfo.designator.departure).format("D MMM YY");
          segmentFlightDetails.departureTime = moment(flightInfo.designator.departure).format("HH:mm");
          segmentFlightDetails.arrivalDateFormate2 = moment(flightInfo.designator.arrival).format("ddd, D MMM");
          segmentFlightDetails.departureDateFormate2 = moment(flightInfo.designator.departure).format("ddd, D MMM");

          const segmentDuration = calculateSegmentDuration(flightInfo);
          segmentFlightDetails.duration = getDurationString(segmentDuration);

          if (index_j < currentJourney.segments.length && currentJourney.segments[index_j + 1]) {
            const templegLayover = calculateSegmentLayoverDuration(flightInfo, currentJourney.segments[index_j + 1]);
            segmentFlightDetails.layover = getDurationString(templegLayover);
          }

          segmentFlightDetails.legFlights = [];
          // terminal in   fo
          for (let index_k = 0; index_k < flightInfo.legs.length; index_k += 1) {
            const legInfo = flightInfo.legs[index_k];
            if (legInfo.legInfo.arrivalTerminal != null) {
              segmentFlightDetails.arrivalTerminal = legInfo.legInfo.arrivalTerminal;
            }
            if (legInfo.legInfo.departureTerminal != null) {
              segmentFlightDetails.departureTerminal = legInfo.legInfo.departureTerminal;
            }
            const originAirportLeg = airports?.find((item) => item?.stationCode === legInfo.designator.origin);
            const destinationAirportLeg = airports?.find(
              (item) => item?.stationCode === legInfo.designator.destination
            );
            const legFlightDetails = {};
            legFlightDetails.flightNumber = segmentFlightDetails.flightNumber;
            legFlightDetails.origin = legInfo.designator.origin;
            legFlightDetails.originAirport = originAirportLeg;
            legFlightDetails.destinationAirport = destinationAirportLeg;
            legFlightDetails.destination = legInfo.designator.destination;
            legFlightDetails.arrival = moment(legInfo.designator.arrival).format("D MMM YY");
            legFlightDetails.flightType = currentJourney.flightType;
            legFlightDetails.arrivalTime = moment(legInfo.designator.arrival).format("HH:mm");
            legFlightDetails.departure = moment(legInfo.designator.departure).format("D MMM YY");
            legFlightDetails.departureTime = moment(legInfo.designator.departure).format("HH:mm");
            legFlightDetails.arrivalDateFormate2 = moment(legInfo.designator.arrival).format("ddd, D MMM");
            legFlightDetails.departureDateFormate2 = moment(legInfo.designator.departure).format("ddd, D MMM");

            const legDuration = calculateLegDuration(legInfo);
            legFlightDetails.duration = getDurationString(legDuration);

            if (index_k < flightInfo.legs.length && flightInfo.legs[index_k + 1]) {
              const templegLayover = calculateLegLayoverDuration(legInfo, flightInfo.legs[index_k + 1]);
              legFlightDetails.layover = getDurationString(templegLayover);
            }
            if (currentJourney.flightType == "Connect") {
              legFlightDetails.layover = segmentFlightDetails.layover;
            }
            segmentFlightDetails.legFlights.push(legFlightDetails);
          }
          tempFlightDetails.stops = flightInfo.legs.length - 1;
          flightInfoArray.push(segmentFlightDetails);
        }
        tempFlightDetails.flights = deepCopy(flightInfoArray);
        journeyDetails.push(tempFlightDetails);
      }
    return journeyDetails;
  } catch (error) {
    console.warn(error);
  }
  return flightInfoArray;
}
